export default __webpack_public_path__ + "static/B0043-3c19ba203c4560233156c5f83b1aa963.png";